import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import { PaginatedResponse } from "@/utils/types/tenantPermissions";
import { getTenantUserById, TenantUser } from "@/utils/types/tenantUser";

const base = "/api/users/";

class TenantUserService {
  listTenantUsers = async (
    page = 1,
    page_size = 20
  ): Promise<PaginatedResponse<TenantUser>> => {
    return await get<PaginatedResponse<TenantUser>>(base, {
      params: { page, page_size },
    });
  };

  getTenantUserById = async (id: string): Promise<getTenantUserById> => {
    if (!id) {
      throwError("ID is required", "TenantUserService");
    }
    return await get<getTenantUserById>(`${base}${id}/`);
  };

  createUser = async (
    user: TenantUser,
    options?: { silent?: boolean }
  ): Promise<TenantUser> => {
    return await post<TenantUser>(base, user, {
      silent: options?.silent,
    });
  };

  updateUser = async (
    id: string,
    user: TenantUser,
    options?: { silent?: boolean }
  ): Promise<TenantUser> => {
    return await put<TenantUser>(`${base}${id}/`, user, {
      silent: options?.silent,
    });
  };

  deleteUser = async (
    id: string,
    options?: { silent?: boolean }
  ): Promise<void> => {
    if (!id) {
      throwError("ID is required", "TenantUserService");
    }
    await del(`${base}${id}/`, { silent: options?.silent });
  };
}

const instance = new TenantUserService();
export default instance;
